/*eslint-disable */
import request from '../../Utils/curl'
import Utility from "../../Utils/utility";

let ChatbotPromptApiObj = {
  /**
   * chatbotPromptList
   */
  async chatbotPromptList (context, whereFilter=null) {
    try{
      Utility.showLoader = true;
      Utility.loadingMsg = "Please wait....";

      let post_data = new FormData();  
      if (whereFilter) {
        post_data.append('filter', JSON.stringify(whereFilter))
      }

      return await request.curl(context, "chatbot_prompt_list", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at chatbotPromptList() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  },

  /**
   * chatbotPromptView
   */
  async chatbotPromptView (context, chatbotPromptId) {
    try {      
      let post_data = new FormData();
      post_data.append('prompt_id', chatbotPromptId);
      return await request.curl(context, "chatbot_prompt_view", post_data)
      .then(async response => {
        return response;
      });
    } 
    catch (err) {
      console.error("Exception occurred at chatbotPromptView() and Exception:",err.message)
    }    
  },

  /**
   * chatbotPromptAdd
   */
  async chatbotPromptAdd (context, chatbotPromptObj) {
    try{
      let post_data = new FormData();
    
      for (let key in chatbotPromptObj) {
        post_data.append(key, chatbotPromptObj[key]);
      }

      return await request.curl(context, "chatbot_prompt_add", post_data)
      .then(async response => {
          return response;
      });
    }
    catch(err){
      console.error('Exception occurred at chatbotPromptAdd() and Exception:',err.message)
    }
  },

  /**
   * chatbotPromptEdit
   */
  async chatbotPromptEdit (context, chatbotPromptObj) {
    try{
      let post_data = new FormData();
        
      for (let key in chatbotPromptObj) {
        post_data.append(key, chatbotPromptObj[key]);
      }

      return await request.curl(context, "chatbot_prompt_edit", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at chatbotPromptEdit() and Exception:',err.message)
    }
  },

  /**
   * chatbotPromptDelete
   */
  async chatbotPromptDelete (context, chatbotPromptId) {
    try{
      let post_data = new FormData();
      
      post_data.append('prompt_id', chatbotPromptId);

      return await request.curl(context, "chatbot_prompt_delete", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.log('Exception occurred at chatbotPromptDelete() and Exception:',err.message)
    }
  }
}

export {
  ChatbotPromptApiObj
}
